// api
import PresentationApi from '@/api/presentation'

// i18n
import { setI18nLocale } from '@/plugins/i18n'

const setPresentationAction = ({ commit }: any, presentation: object) => {
  commit('setPresentation', presentation)
}

const getPresentationAction = async ({ commit }: any, moderationCode: string) => {
  const presentation = await PresentationApi.getPresentation(moderationCode)
  commit('setPresentation', presentation)

  // Standalone fallback: when not embedded (no ?lang= passed by the presenter),
  // match the UI language to the presentation's content language so the page is
  // still translated instead of defaulting to English. When embedded, the
  // presenter's UI language passed via ?lang= takes precedence and must not be
  // overridden by the presentation's content language.
  if (!new URLSearchParams(window.location.search).get('lang')) {
    setI18nLocale(presentation?.language)
  }

  return presentation
}

export default {
  setPresentationAction,
  getPresentationAction,
}
